
export default class VideoBanner {

  constructor(element, options) {

    this.element = element;
    this.options = options;

    this.init();
    this.watch();
  }

  init() {

    let doc = this.element.ownerDocument;
    this.window = doc.defaultView || doc.parentWindow;

    //extract sources from <source> tags
    let sources = this.element.querySelectorAll("source");
    this.sourceArray = [...sources].map((e) => {
      return {
        "media": e.getAttribute("media"),
        "src": e.getAttribute("src")
      };
    });

    //remove <source> tags
    for (const elem of sources) {
      elem.remove();
    }

    this.updateSource();

  }

  watch() {

    let self = this;

    this.window.addEventListener("resize",
      self.debounce(self.updateSource.bind(self), self.options.refreshRate)
    );

  }

  debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }

  updateSource() {

    let determinedSource;

    this.sourceArray.forEach((e) => {

      let windowWidth = this.window.innerWidth;

      if (e.media) {
        let [dir, width] = e.media.split(":");
        dir = dir.trim().toLowerCase();
        width = parseInt(width.replace(/\D/g, ''));

        if (
          (dir === "min-width" && windowWidth > width) ||
          (dir === "max-width" && windowWidth < width)
        ) {
          determinedSource = e.src;
        }

      } else if (determinedSource == null) {
        determinedSource = e.src;
      }
    });

    let currentSource = this.element.getAttribute("src");
    if (determinedSource != currentSource) {
      this.element.setAttribute("src", determinedSource);
    }
  }


}

VideoBanner.DEFAULTS = {
  refreshRate: 300
};


// WEBPACK FOOTER //
// ./project/client/src/core/components/video-banner/video-banner.js